module.exports = __webpack_public_path__ + "img/pressureRoad-icon4.16044b56.png";